export const parseTime = (time) => {
  const t = new Date(time).toLocaleTimeString("en-GB").split(":");
  return `${t[0]}:${t[1]}`;
};
export const parseDate = (date) => {
  const newDate = new Date(date);
  return newDate.toLocaleString("en-GB");
};

export const getTimeZoneOffset = () => {
  const timeZoneOffset = new Date().getTimezoneOffset();
  const hoursOffset = Math.floor(Math.abs(timeZoneOffset) / 60);
  const minutesOffset = Math.abs(timeZoneOffset) % 60;
  const sign = timeZoneOffset > 0 ? "-" : "+";
  const offSet = `${sign}${hoursOffset}:${String(minutesOffset).padStart(
    2,
    "0"
  )}`;
  return offSet;
};

export const maxAllowedDobDate = () => {
  return new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth(),
    new Date().getDate()
  )
    .toISOString()
    .slice(0, 10);
};

export const validateDOB = (value) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(value)) {
    return "Please use YYYY-MM-DD format.";
  }

  const parts = value.split("-");
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);

  if (month < 1 || month > 12) {
    return "Month must be between 01 and 12.";
  }

  if (day < 1 || day > new Date(year, month, 0).getDate()) {
    return `Invalid day for selected month.`;
  }
  const inputDate = new Date(value);
  const minDate = new Date("01-01-1900");
  const maxDate = new Date(maxAllowedDobDate());
  if (inputDate < minDate) {
    return "Please use valid year";
  }

  if (inputDate > maxDate) {
    return `Date must be on or before ${maxAllowedDobDate()}.`;
  }

  return true;
};
